import React from 'react';
import OdfjellInputComponent, { InputChangeData } from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import { BunkerReceived } from 'src/types/ViewModel/Bunkering/BunkerReceived';
import { FuelRobColumn } from 'src/types/ViewModel/Bunkering/FuelRobColumn';

interface Props {
    fuelRobColumn: FuelRobColumn;
    tankId: number;
    onChangeDebunkering: (changeObject: InputChangeData, debunkerValue: BunkerReceived, column: FuelRobColumn, oldValue: number) => void;
}

const DebunkeringInput: React.FC<Props> = ({ fuelRobColumn, tankId, onChangeDebunkering }) => {
    const debunkeringValue = fuelRobColumn.debunkeringPerTank?.find((r) => r.tankId === tankId);

    return (
        <OdfjellInputComponent
            type="number"
            value={debunkeringValue?.bunkerReceivedMt}
            onChange={(changeObject) => onChangeDebunkering(changeObject, debunkeringValue, fuelRobColumn, debunkeringValue?.bunkerReceivedMt)}
            unit="MT"
        />
    );
};

export default DebunkeringInput;
